<template>
  <div>
    <div v-if="$route.path.indexOf('_editor') === -1">
      <el-row :gutter="20">

        <el-col :md="8" :lg="4">
            <el-select size="small" v-model="params.rebate_type" clearable placeholder="返佣类型" @change="typesearch">
                <el-option v-for="item in rebate_type" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
            </el-select>
        </el-col>
          <el-col :md="6" :lg="5">
              <el-select size="small" v-model="params.order_cancle_flag" clearable placeholder="是否取消" @change="cancelsearch">
                  <el-option v-for="item in order_cancle_flag" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
              </el-select>
          </el-col>
        <el-col :span="5">
          <el-input placeholder="订单id" v-model="params.order_id" style="width: 100%" size="mini"><el-button slot="append" icon="el-icon-search" @click="searchData"></el-button></el-input>
        </el-col>
        <el-col :md="10" :lg="8">
            <el-date-picker v-model="upload_at" type="daterange" start-placeholder="返现时间" ange-separator="至" end-placeholder="返现时间" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="updateDateChange" size="mini"></el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="17">
            <section class="section-card realtime-statics" v-loading="userloading">
                <div class="section-card-header">
                    <div class="section-card-title">
                        实时概况
                    </div>
                    <div class="header-small">
                        更新时间：{{Date.now()/1000 | datetime('yyyy-MM-dd hh:mm:ss')}}
                    </div>
                    <!-- <ul class="header-filters">
                        <li class="filter-item">全店</li>
                        <li class="filter-item">网店</li>
                        <li class="filter-item">所有门店</li>
                    </ul> -->
                </div>
                <div>
                    <el-row class="analysis" :gutter="20">
                        <el-col :span="12">
                            <div class="view-flex">
                                <div class="view-flex-item">
                                    <div class="label">返现</div>
                                    <div class="real-data">{{SumMoney}}</div>
                                </div>
                                <div class="view-flex-item">
                                    <div class="label">优惠券</div>
                                    <div class="real-data">{{SumCoupon}}</div>

                                </div>

                                <div class="view-flex-item">
                                    <div class="label">人数</div>
                                    <div class="real-data">{{SumPeople}}</div>

                                </div>
                            </div>
                        </el-col>

                    </el-row>

                </div>
            </section>
        </el-col>
    </el-row>
   <el-table :data="catesList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>

      <el-table-column prop="order_id" label="订单号" width="180"></el-table-column>
      <el-table-column prop="spread_user_id" label="推广人用户ID" width="120"></el-table-column>
      <el-table-column prop="user_id" label="用户 ID" width="120"></el-table-column>
      <el-table-column prop="rebate_type" label="返佣类型" width="180">
        <template slot-scope="scope">
            <el-tag size="mini" effect="plain" type="success" v-if="scope.row.rebate_type=='cash'">现 金</el-tag>
            <el-tag size="mini" effect="plain" v-else>优惠券</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="rebate_fee" label="返佣" width="150"></el-table-column>
      <el-table-column prop="rebate_type" label="是否进入返现队列" width="80">
        <template slot-scope="scope">
            <el-tag size="mini" effect="plain" type="success" v-if="scope.row.is_queue==1">是</el-tag>
            <el-tag size="mini" effect="plain" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="is_rebate" label="是否返现成功" width="80">
        <template slot-scope="scope">
            <el-tag size="mini" effect="plain" type="success" v-if="scope.row.is_rebate==1">是</el-tag>
            <el-tag size="mini" effect="plain" v-else>否</el-tag>
        </template>
      </el-table-column>
       <el-table-column prop="is_rebate" label="订单是否取消" width="80">
           <template slot-scope="scope">
               <el-tag size="mini" effect="plain" type="success" v-if="scope.row.order_cancle_flag==1">是</el-tag>
               <el-tag size="mini" effect="plain" v-else>否</el-tag>
           </template>
       </el-table-column>
      <el-table-column prop="inqueue_at" label="进入返现队列时间" width="200">
          <template slot-scope="scope">{{scope.row.inqueue_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
      </el-table-column>
      <el-table-column prop="rebated_at" label="成功返现时间" width="200">
          <template slot-scope="scope">{{scope.row.rebated_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
      </el-table-column>
      <el-table-column prop="created_at" label="记录创建时间" width="200">
          <template slot-scope="scope">{{scope.row.created_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
      </el-table-column>
    </el-table>
    <div v-if="total_count > params.pageSize" class="content-padded content-center">
        <el-pagination
                background
                layout="prev, pager, next"
                @current-change="handleCurrentChange"
                :current-page.sync="params.page"
                :total="total_count" :page-size="params.pageSize">
        </el-pagination>
    </div>

  </div>
  </div>
</template><script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import {getRebateList} from '@/api/spread'
  export default {
    data () {
      return {
        isEdit: false,
        upload_at:'',
        userloading: true,
        SumMoney:0,
        SumCoupon:0,
        SumPeople:0,
        catesList: [],
        loading: false,
        rebate_type:[
              { name: '现 金', value: 'cash' },
              { name: '优惠券', value: 'coupon' }
          ],
          order_cancle_flag:[{name:'取消',value:'1'},
              {name:'没取消',value:'0'}
          ],
        total_count: 0,
        params: {
          page: 1,
          pageSize: 20,
        },
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },

      searchData () {
        this.params.page = 1
        this.getDataList()
      },
      getDataList () {

        this.loading = true
        getRebateList(this.params).then(response => {

          this.catesList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.SumMoney = response.data.data.SumMoney
          this.SumCoupon = response.data.data.SumCoupon
          this.SumPeople = response.data.data.total_count
          this.loading = false
          this.userloading = false
        })
      },
      typesearch (){
          this.getDataList()
      },
        cancelsearch(){
            this.getDataList()
        },
      handleCancelLabelsDialog () {
        this.memberTagDialog = false
      },
      updateDateChange (val) {
          if (val && val.length > 0) {
              this.params.start_upload_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
              this.params.end_upload_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
          } else {
              this.params.start_upload_at = ''
              this.params.end_upload_at = ''
          }
          console.log(this.params)
          this.getDataList();
      },
      dateStrToTimeStamp (str) {
          return Date.parse(new Date(str))/1000
      },
    },
    mounted () {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>
<style scoped lang="scss">
    .main {
        min-width: 1024px;
    }
    .unbind-box {
        display: flex;
        align-items: center;
        justify-content: center;
    height: 285px;
        .iconfont {
            display: block;
            margin-bottom: 20px;
            font-size: 70px;
            line-height: 1;
            color: #eaeaea;
        }
    p {
      margin-bottom: 20px;
    }
  }

    .section-card {
        padding: 30px;
        background: #fff;
        box-shadow: 0 0 10px rgba(0,0,0,0.1);
        &.realtime-statics {
            height: 138px;
        }
        &.chart-statics {
            height: 318px;
        }
        .section-card-header {
            display: flex;
            align-items: flex-end;
            padding-bottom: 20px;
            .section-card-title {
                margin-right: 20px;
                font-size: 16px;
                font-weight: 600;
            }
            .header-small {
                flex: 1;
                font-size: 12px;
                color: #ccc;
            }
            .header-filters {
                display: flex;
                .filter-item {
                    position: relative;
                    padding: 0 15px;
                    color: #999;
                    font-size: 12px;
                    &::after {
                        position: absolute;
                        left: 0;
                        top: 20%;
                        bottom: 20%;
                        width: 1px;
                        background: #efefef;
                        content: "";
                    }
                    &:first-child::after {
                        content: none;
                    }
                }
            }
        }
    }

    .company {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 285px;
        .logo {
            margin-bottom: 20px;
            width: 70px;
            height: 70px;
            border-radius: 100%;
        }
        .name {
            margin-bottom: 10px;
            font-size: 14px;
        }
        .operate {
            padding-bottom: 50px;
        }
        .validity-period {
            display: flex;
            font-size: 12px;
            color: #999;
            .iconfont {
                margin-right: 10px;
                font-size: 12px;
            }
        }
    }

    .analysis {
        padding-left: 20px;
        padding-top: 10px;
        .label {
            font-size: 12px;
            color: #999;
        }
        .real-data {
            font-size: 20px;
            font-family: "Helvetica Neue";
            font-weight: 500;
        }
        .history-data {
            font-size: 12px;
            color: #ccc;
        }
    }

    .notices {
        padding-left: 20px;
        .notices-group {
            padding: 10px 0;
        }
        .subtitle {
            padding-bottom: 10px;
            font-size: 14px;
            color: #666;
        }
        .notice-item {
            font-size: 12px;
            color: #999;
            cursor:pointer;
        }
    }

    .quick-link {
        padding-left: 20px;
        .link-item {
            float: left;
            width: 230px;
            margin: 10px 0;
            color: #666;
            cursor:pointer;
            .iconfont {
                display: inline-block;
                margin-right: 10px;
                width: 25px;
                height: 25px;
                line-height: 25px;
                text-align: center;
                border-radius: 5px;
                color: #fff;
                font-size: 12px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// cashback.vue?71ad61d2